import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppSettings } from '../configs/core.config';
//import { RESTServices } from '../../core/services/rest.service';
import { LoginService } from '../../login/login.service';
import { CustomHttpParamEncoder } from './custom-http-param-encoder';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { FRStep } from '@forgerock/javascript-sdk';
import { catchError, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthOWAService {
  public username!: string;
  public password!: string;
  public step?: FRStep | undefined;
  public setSpinnerLoading = new BehaviorSubject<boolean>(false);
  public resetStep = new BehaviorSubject<FRStep|undefined>(this.step);
  private readonly REQUEST_TIMEOUT = 30000; // 30 seconds

  constructor(
    private http: HttpClient,
   // private REST: RESTServices,
    private loginService: LoginService
    ) { }

  public accessURL(url: string) {
    let envURL = decodeURIComponent(url);
    const qaEnvURLArray = envURL.match(/qa.advisormail.lpl.com/g);
    const devEnvURLArray = envURL.match(/devint.advisormail.lpl.com/g);
    if (qaEnvURLArray) {
      envURL = qaEnvURLArray[0];
      return envURL;
    } else if (devEnvURLArray) {
      envURL = devEnvURLArray[0];
      return envURL;
    } else {
      return envURL;
    }
  }

  public authOWA(): Observable<any> {
    const emailVal = this.loginService.email;
    const passwordVal = this.loginService.password;
    if (!emailVal || !passwordVal) {
      return throwError(() => new Error(
        'User credentials are not available. Please sign in again.'
      ));
    }

    const beforeAtTheRateVal = emailVal.split('@');
    this.username = beforeAtTheRateVal[0] + '@web.lpl.com';
    this.password = passwordVal;

    const body: HttpParams = new HttpParams({ encoder: new CustomHttpParamEncoder() })
      .set('destination', AppSettings.AuthOWA_Url + '/owa/')
      .set('flags', '4')
      .set('forcedownlevel', '0')
      .set('username', this.username)
      .set('password', this.password)
      .set('passwordText', '')
      .set('trusted', '4')
      .set('isUtf8', '1');

    return this.http
      .post(AppSettings.authOWA, body,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
      .pipe(
        timeout(this.REQUEST_TIMEOUT),
        catchError((error) => {
          console.error('AuthOWA service error:', error);
          return throwError(() => error);
        })
      );
  }
}
